import React, { Component } from 'react';

import { Button, Container } from 'reactstrap';
import CreatePlcSafetyZoneDependencyForm from '../../components/Forms/CreatePlcSafetyZoneDependencyForm';

class NewPlcSafetyZoneDependency extends Component {
  goBack(event) {
    event.preventDefault();
    this.props.history.push('/plcSafetyZoneDependencies');
  }

  render() {
    return (
      <div className="user-management">
        <Container fluid>
          <Button className="btn btn-primary waves-effect waves-light usersButtons" onClick={(event) => this.goBack(event)}>
            <i className="fas fa-arrow-left"></i>
          </Button>
          <CreatePlcSafetyZoneDependencyForm />
        </Container>
      </div>
    );
  }
}

export default NewPlcSafetyZoneDependency;
